export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/no-accidents.1c1161cc.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};